module.exports = __webpack_public_path__ + "img/logo.bdf074e7.png";